<template>
    <v-row class="pa-3">
        <v-col cols="2">
            <v-btn-primary @click="editTaxFrom" block>Ajouter</v-btn-primary>
        </v-col>
        <v-col cols="10"> </v-col>
        <v-col cols="12">
            <oss-data-table
                :headers="headers"
                :items="declarationForms"
                :striped="true"
                :table-hover="true"
                :dense="true"
                @clickRow="editTaxFrom($event)"
            >
                <template v-slot:item.status="{ item }">
                    <v-chip
                        class="ma-2"
                        large-chip
                        filter
                        link
                        :color="getColor(item.status)"
                        size="small"
                    >
                        {{ declarationStatus[item.status] }}
                    </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                            <v-btn-icon icon="$dots_vertical" v-bind="props" />
                        </template>
                        <v-list>
                            <v-list-item @click.stop="editTaxFrom(item)">
                                <v-list-item-title>Editer</v-list-item-title>
                                <template #append>
                                    <v-icon size="small">$oss-edit</v-icon>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>
            </oss-data-table>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import gql from "graphql-tag";

import { Apollo } from "@/decorators";

import OssDataTable from "../../ossComponents/ossDataTable2.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        OssDataTable,
    },
    emits: ["editTaxFrom"],
})
export class TaxFormTablePlayground extends Vue {
    get headers() {
        return [
            { text: "Nom du formulaire", value: "name" },
            { text: "Numéro cerfa", value: "cerfaNumber" },
            { text: "Année", value: "year" },
            { text: "Statut", value: "status" },
            { text: "Actions", value: "actions", sortable: false },
        ];
    }

    declarationStatus = {
        EDITION: "Edition",
        PENDING_VALIDATION: "En attente de validation",
        VALIDATED: "Validé",
    };

    @Apollo({
        query: gql`
            query DeclarationForms {
                declarationForms(orderBy: year_DESC, where: { type: VERSION2 }) {
                    id
                    cerfaNumber
                    name
                    version
                    year
                    type
                    status
                }
            }
        `,
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.declarationForms) {
                    this.declarationForms = data.declarationForms;
                }
            }
        },
    })
    declarationForms: any = [];

    getColor(item) {
        switch (item) {
            case "EDITION":
                return "orange";
            case "VALIDATED":
                return "green";
            case "PENDING_VALIDATION":
                return "blue en-1";
            default:
                return "orange";
        }
    }

    editTaxFrom(taxForm) {
        this.$emit("editTaxFrom", taxForm.id);
    }
}

export default toNative(TaxFormTablePlayground);
</script>
